<template>
  <v-app>
    <Header :isPublic="true" />
    <v-main>
      <div id="body">
      <v-row style="margin-left: 30px">
        <v-col cols="4">
          <v-text-field
            label="Pesquisar por Assunto"
            v-model="filtro.assunto"
            v-on:keyup.enter="buscarLicitacao()"
          />
        </v-col>
        <v-col cols="2">
          <v-text-field
            type="number"
            label="Número"
            v-model="filtro.numero"
            v-on:keyup.enter="buscarLicitacao()"
          />
        </v-col>
        <v-col cols="2">
          <v-text-field
            type="number"
            label="Ano"
            v-model="filtro.ano"
            v-on:keyup.enter="buscarLicitacao()"
          />
        </v-col>

        <v-col cols="3" style="margin-top: 10px">
          <v-select
            solo
            dense
            v-model="filtro.enteFederativo"
            :items="undefined"
            item-text="undefined"
            item-value="undefined"
            label="Ente Federativo"
          ></v-select>
        </v-col>
      </v-row>

      <v-row style="margin-left: 30px">
        <v-col cols="4">
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            label="Órgão Licitante"
            v-model="filtro.orgaoLicitante"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            label="Número Procedimento"
            v-model="filtro.numeroProcedimento"
          />
        </v-col>

        <v-col cols="2">
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            label="Data Sessao Inicial"
            type="date"
            v-model="filtro.dataSessaoInicial"
          />
        </v-col>

        <v-col cols="2">
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            label="Data Sessao Final"
            type="date"
            v-model="filtro.dataSessaoFinal"
          />
        </v-col>
      </v-row>

      <v-row style="margin-left: 30px">
        <v-col cols="4">
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            label="Objeto"
            type=""
            v-model="filtro.objeto"
          />
        </v-col>

        <v-col cols="3" style="margin-top: 10px">
          <v-select
            solo
            dense
            v-model="filtro.codProcedimento"
            :items="undefined"
            item-text="undefined"
            item-value="undefined"
            label="Cod Procedimento"
          ></v-select>
        </v-col>

        <v-col cols="3" style="margin-top: 10px">
          <v-select
            solo
            dense
            v-model="filtro.finalidade"
            :items="undefined"
            item-text="undefined"
            item-value="undefined"
            label="Finalidade"
          ></v-select>
        </v-col>

        <v-col cols="1" style="margin-top: 13px;">
          <v-btn
            style="width: 100%;"
            color="primary"
            depressed
            :loading="loadingBusca"
            :disabled="loadingBusca"
            @click="buscarLicitacao()"
          >
            <v-icon>fa-search</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-alert v-if="erroServico" type="error" outlined dense class="mt-4">
        Não foi possível consultar as licitações no momento. Tente novamente em instantes.
      </v-alert>

      <v-row justify="center">
        <v-col cols="12" md="12">
          <template>
            <v-data-table
              @click:row="abrirDialog"
              :headers="headers"
              :items="lista"
              :items-per-page="10"
              :loading="loadingBusca"
              class="elevation-1 mytable"
              no-results-text="A busca não trouxe resultados."
              :no-data-text="erroServico ? 'Não foi possível carregar os dados.' : 'A busca não trouxe resultados.'"
            >
              <template v-slot:loading>
                <LoadingSpinner text="Carregando licitações... aguarde." />
              </template>
            </v-data-table>
          </template>

          <v-dialog v-model="dialog" max-width="700px">
            <v-card>
              <v-card-title class="grey lighten-2"
                >{{ licitacao.tipoLicitacao.nome }}: {{ licitacao.numero }} /
                {{ licitacao.ano }}
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        class="font-weight-black"
                        disabled
                        label="Número"
                        v-model="licitacao.numero"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        class="font-weight-black"
                        disabled
                        label="Ano"
                        v-model="licitacao.ano"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        class="font-weight-black"
                        disabled
                        label="Tipo"
                        v-model="licitacao.tipoLicitacao.nome"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" style="margin-top:-5px">
                      <div
                        style="padding:10px"
                        class="elevation-1 font-weight-black"
                      >
                        {{ licitacao.assunto }}
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <template>
                        <v-data-table
                          hide-default-footer
                          :headers="headersAnexo"
                          :items="licitacao.itensLicitacao"
                          :items-per-page="10"
                          class="elevation-1"
                          no-results-text="A busca não trouxe resultados."
                          no-data-text="A busca não trouxe resultados."
                        >
                          <template v-slot:item.dataFormatada="{ item }">
                            <span>{{
                              new Date(
                                $moment(item.data).format()
                              ).toLocaleDateString()
                            }}</span>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mr-2"
                                  @click="download(item)"
                                  >mdi-download</v-icon
                                >
                              </template>
                              <span>Download</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false"
                  >Fechar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/template/Header.vue";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";
import licitacaoService from "@/service/LicitacaoService";
import Licitacao from "@/model/licitacao";
export default {
  components: {
    Header,
    LoadingSpinner
  },
  data() {
    return {
      dialog: false,
      loadingBusca: false,
      erroServico: false,
      filtro: {
        assunto: null,
        numero: null,
        ano: null,
        enteFederativo: null, //select
        orgaoLicitante: null,
        codProcedimento: null, //select
        finalidade: null, //select
        numeroProcedimento: null,
        anoProcedimento: null,
        objeto: null,
        dataSessaoInicial: null,
        dataSessaoFinal: null,
      },
      tiposLic: [],
      lista: [],
      licitacao: Licitacao(),
      headers: [
        { text: "Número", value: "numero", align: "center", sortable: false },
        { text: "Ano", value: "ano", sortable: false },
        {
          text: "Tipo",
          value: "tipoLicitacao.nome",
          width: "15%",
          sortable: false,
        },
        { text: "Assunto", value: "assunto", sortable: false },
      ],
      headersAnexo: [
        { text: "Descrição", value: "descricao", sortable: false },
        { text: "Arquivo", value: "arquivo", sortable: false },
        { text: "Data", value: "dataFormatada", sortable: false },
        {
          text: "Download",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    buscarLicitacao() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.loadingBusca = true;
      this.erroServico = false;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      licitacaoService
        .buscarLicitacaoFiltro(this.filtro)
        .then((result) => (this.lista = result || []))
        .catch(() => {
          // falha real (rede/API fora do ar): aviso de indisponibilidade
          this.lista = [];
          this.erroServico = true;
        })
        .finally(() => (this.loadingBusca = false));
    },
    abrirDialog(item) {
      Object.assign(this.licitacao, item);
      this.dialog = true;
    },
    download(item) {
      if (item.arquivo.length > 0 && item.itemLicitacaoId != null) {
        licitacaoService.downloadAnexo(item.itemLicitacaoId);
      } else {
        alert("Este Anexo não possui arquivo para Download!");
      }
    },
  },
  created() {
    licitacaoService.findAllTipos().then((result) => (this.tiposLic = result));

    this.buscarLicitacao();
  },
};
</script>

<style></style>
